import {
  MockMap,
} from '@ama-sdk/core';
import {
  Email,
  Journey,
  JourneyElementCommon,
} from '@dapi/sdk';
import {
  AcceptanceRepository,
  BaggageRepository,
  combineBoardingPassResults,
  combineCheckInBaggagePolicies,
  combineJourneys,
  combineJourneyTravelers,
  createJourney,
  createMockData,
  createMockDataWithResponse,
  JourneyTravelerRepository,
  RecursivePartial,
  RegulatoryDetailsReplyDataRepository,
} from '@dapi/sdk/spec';
import {
  sentBoardingPassResult,
} from '../../mock/data';
import {
  contactPhone,
} from '../../mock/dictionaries';
import {
  retrieveSeatMapsJourneyDriven,
} from './common/seatmap';

const email1: Email = {
  address: 'first.traveler@amadeus.com',
  category: 'personal',
  contactType: 'Email',
  purpose: 'notification'
};

const email2: Email = {
  address: 'second.traveler@amadeus.com',
  category: 'personal',
  contactType: 'Email',
  purpose: 'notification'
};

const journeyTemplate: RecursivePartial<Journey> = {
  travelers: combineJourneyTravelers([JourneyTravelerRepository.MAN, JourneyTravelerRepository.CHD, JourneyTravelerRepository.INF], {}).items,
  contacts: [email1, email2]
};

const journeys = combineJourneys([journeyTemplate, journeyTemplate]).items;

const journeyElementIds = journeys[0].journeyElements.map((je: JourneyElementCommon) => je.id);

const seatmap = retrieveSeatMapsJourneyDriven(journeys[0], journeys[0].travelers.map((t) => t.id).filter((id): id is string => !!id));

export const ow1Journey1Adt1Chd1InfMultiBpEmailRetrieve: MockMap = {
  generateBoardingPasses: [createMockDataWithResponse(combineBoardingPassResults(undefined, {
    journeyElementIds
  }).items, 201),
  createMockDataWithResponse(combineBoardingPassResults(sentBoardingPassResult, {
    journeyElementIds
  }).items, 201)
  ],
  getBaggagePoliciesFromJourney: [createMockData(combineCheckInBaggagePolicies().items)],
  getJourneyUnpaidItems: [createMockDataWithResponse(undefined, 404, [{
    code: '10000',
    title: 'No unpaid service',
    type: 'error',
    id: '10000'
  }])],
  getRegulatoryDetails: [createMockData(RegulatoryDetailsReplyDataRepository.DEFAULT)],
  requestAcceptanceOfJourney: [createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201), createMockDataWithResponse(AcceptanceRepository.ACCEPTED, 201)],
  retrieveJourneyBaggages: [createMockData([BaggageRepository.DEFAULT])],
  retrieveJourneys: [
    createMockDataWithResponse(journeys, 201),
    createMockDataWithResponse([{
      ...journeys[0],
      acceptance: AcceptanceRepository.ACCEPTED
    }, journeys[1]], 201),
    createMockDataWithResponse([{
      ...journeys[0],
      acceptance: AcceptanceRepository.ACCEPTED
    }, {
      ...journeys[1],
      acceptance: AcceptanceRepository.ACCEPTED
    }], 201),
    createMockDataWithResponse([{
      ...journeys[0],
      acceptance: AcceptanceRepository.ACCEPTED
    }, {
      ...journeys[1],
      acceptance: AcceptanceRepository.ACCEPTED
    }], 201)
  ],
  retrieveJourney: [
    createMockData(createJourney({
      template: {
        ...journeys[0],
        acceptance: AcceptanceRepository.ACCEPTED
      }
    })),
    createMockData(createJourney({
      template: {
        ...journeys[1],
        acceptance: AcceptanceRepository.ACCEPTED
      }
    }))
  ],
  retrieveSeatMapsJourneyDriven: [createMockData(seatmap)],
  addContactsToJourney: [
    createMockDataWithResponse([{
      ...email1,
      travelerIds: ['JOURNEY-TRAVELER-0-MOCK']
    },
    {
      ...contactPhone,
      purpose: 'notification',
      countryPhoneExtension: '33',
      number: '0623456789',
      travelerIds: ['JOURNEY-TRAVELER-0-MOCK']
    },
    {
      ...email1,
      travelerIds: ['JOURNEY-TRAVELER-1-MOCK']
    },
    {
      ...contactPhone,
      purpose: 'notification',
      countryPhoneExtension: '33',
      number: '0623456781',
      travelerIds: ['JOURNEY-TRAVELER-1-MOCK']
    }
    ], 201)
  ]
};
